import "core-js/modules/web.dom-collections.iterator.js";
import React, { useCallback, useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { IconButton, LinkButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { DELETED_ROW_ID } from '../types/list-question-type';
import SelectInput from '../types/select-input';
import { StandardInputField } from '../types/standard-input-field';
import { composeValidators, configurableMinLengthValidator, focusOnErrors, requiredField, valueNotAllowed } from '../util/validator';
import OverlayLoader from './overlay-loader';
const SourceOfIncomeSection = _ref => {
  let {
    submitButtonText,
    submitSourceOfIncome,
    onSubmit,
    submitSourceOfIncomeSection,
    sourceOfIncomeQuestionSection,
    error,
    minCommentLength
  } = _ref;
  const [sourceOfIncomeRows, setSourceOfIncomeRows] = useState([]);
  const [lastUsedIndex, setLastUsedIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (submitSourceOfIncome.submitted) {
      setLoading(false);
      onSubmit();
    }
  }, [submitSourceOfIncome.submitted, onSubmit]);
  const {
    questions,
    header,
    mainQuestion
  } = sourceOfIncomeQuestionSection;

  // TODO: initialValues can be used to prefill fields when we get that far. Then this could/should be removed
  const initialValues = {};
  const sourceOfIncomeTexts = {
    sourceId: 'Velg kilden',
    amount: 'Beløp',
    comment: 'Kommentar/forklaring'
  };
  const addRow = useCallback(() => {
    const id = "".concat(Math.random()).slice(2).padEnd(20, '0');
    const newIndex = lastUsedIndex + 1;
    setLastUsedIndex(newIndex);
    const newRow = {
      id,
      index: newIndex
    };
    setSourceOfIncomeRows([...sourceOfIncomeRows, newRow]);
  }, [sourceOfIncomeRows, lastUsedIndex]);
  useEffect(() => {
    if (sourceOfIncomeRows.length === 0) {
      addRow();
    }
  }, [addRow, sourceOfIncomeRows.length]);
  const onRemove = (id, setValueOfField) => {
    const indexToRemove = sourceOfIncomeRows.findIndex(row => id === row);
    if (indexToRemove >= 0) {
      const newRows = [...sourceOfIncomeRows];
      newRows[indexToRemove].id = DELETED_ROW_ID;
      setSourceOfIncomeRows(newRows);
      if (setValueOfField) {
        setValueOfField({
          key: "_".concat(indexToRemove),
          value: undefined
        });
      }
    }
  };
  const sourcesOfIncome = questions === null || questions === void 0 ? void 0 : questions.map(question => {
    return {
      text: question.text,
      value: question.sourceId.toString()
    };
  });
  const getRows = (values, setValueOfField) => {
    return sourceOfIncomeRows && sourceOfIncomeRows.map((row, i) => {
      if (row.id !== DELETED_ROW_ID) {
        return /*#__PURE__*/React.createElement("div", {
          key: row.index,
          className: "source-of-income-wrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "sub-question-wrapper"
        }, i !== 0 && /*#__PURE__*/React.createElement(IconButton, {
          className: "sgw-button remove-icon",
          id: "removeItem",
          onClick: () => {
            onRemove(row, setValueOfField);
          },
          icon: IconTypes.KRYSS_24,
          screenReaderText: "fjern svar for inntekstkilde"
        }), /*#__PURE__*/React.createElement("div", {
          className: "form-question"
        }, /*#__PURE__*/React.createElement(SelectInput, {
          label: sourceOfIncomeTexts.sourceId,
          name: "_".concat(i, ".sourceId"),
          values: [{
            text: 'Velg',
            value: 'velg'
          }, ...sourcesOfIncome],
          validate: composeValidators(requiredField, value => valueNotAllowed(value, 'velg', 'Velg'))
        })), /*#__PURE__*/React.createElement("div", {
          className: "form-question"
        }, /*#__PURE__*/React.createElement(StandardInputField, {
          type: "number",
          label: sourceOfIncomeTexts.amount,
          name: "_".concat(i, ".amount"),
          validate: requiredField
        })), /*#__PURE__*/React.createElement("div", {
          className: "form-question"
        }, /*#__PURE__*/React.createElement(StandardInputField, {
          label: sourceOfIncomeTexts.comment,
          name: "_".concat(i, ".comment"),
          validate: composeValidators(requiredField, value => configurableMinLengthValidator(value, minCommentLength))
        }))));
      }
      return undefined;
    });
  };
  const getObjectToSubmit = values => {
    return Object.keys(values).filter(key => key.startsWith('_')).map(key => {
      return {
        amount: values[key].amount,
        comment: values[key].comment,
        sourceId: values[key].sourceId,
        version: 1
      };
    });
  };
  const submitAnswers = values => {
    setLoading(true);
    submitSourceOfIncomeSection(getObjectToSubmit(values));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading && !error ? /*#__PURE__*/React.createElement(OverlayLoader, null) : undefined, header && /*#__PURE__*/React.createElement("h2", null, header), /*#__PURE__*/React.createElement(Form, {
    onSubmit: submitAnswers,
    decorators: [focusOnErrors],
    initialValues: initialValues,
    mutators: {
      setValueOfField: (args, state, utils) => {
        utils.changeValue(state, args[0].key, () => args[0].value);
      }
    }
  }, props => {
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: props.handleSubmit
    }, /*#__PURE__*/React.createElement("div", {
      className: "source-of-income",
      id: "sourceOfIncome"
    }, mainQuestion && /*#__PURE__*/React.createElement("h3", null, mainQuestion), getRows(props.values, props.form.mutators.setValueOfField), /*#__PURE__*/React.createElement(LinkButton, {
      id: "addMore",
      icon: IconTypes.PLUSS_24,
      onClick: addRow
    }, "Legg til")), /*#__PURE__*/React.createElement(StandardButton, {
      className: "progress-next-button",
      type: "submit"
    }, submitButtonText));
  }));
};
export default SourceOfIncomeSection;